import { motion } from "framer-motion";

const cols = [
  {
    label: "Product Craft",
    items: [
      "0 → 1 launches",
      "Roadmapping & OKRs",
      "Discovery & user research",
      "Experimentation (A/B)",
      "PRDs that ship",
    ],
  },
  {
    label: "Payments Depth",
    items: [
      "Digital wallets",
      "Merchant onboarding",
      "KYC / KYB",
      "Risk & fraud rails",
      "Cross-border rails",
    ],
  },
  {
    label: "AI & Data",
    items: [
      "LLM evaluation",
      "Prompt design",
      "Guardrails & safety",
      "SQL / analytics",
      "Metrics frameworks",
    ],
  },
  {
    label: "Tooling",
    items: ["Figma", "Amplitude", "Mixpanel", "Notion", "Linear", "Metabase"],
  },
];

const About = () => {
  return (
    <section
      id="about"
      className="relative py-28 md:py-40 border-t border-[var(--bone)]/10"
      data-testid="about-section"
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-10 grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-20%" }}
          transition={{ duration: 0.9 }}
          className="md:col-span-5"
        >
          <div className="font-mono text-[11px] tracking-[0.28em] uppercase text-[var(--copper)] mb-4">
            [ Chapter V — About ]
          </div>
          <h2 className="font-serif text-5xl md:text-7xl leading-[0.95] text-[var(--bone)]">
            Off the record,
            <br />
            <span className="italic text-[var(--bone-dim)]">on the ledger.</span>
          </h2>

          <p className="mt-10 text-[var(--bone)]/80 text-lg md:text-xl font-light leading-relaxed max-w-md">
            I'm a payments PM working at the intersection of trust, speed and
            AI. I've shipped wallets used by millions, launched merchant rails
            in emerging markets, and now build the evaluation layer that keeps
            AI honest in production.
          </p>
          <p className="mt-6 text-[var(--bone-dim)] text-base font-light leading-relaxed max-w-md">
            When I'm not writing PRDs, I'm reading long-form journalism, chasing
            good light with a film camera, or explaining to friends why UPI
            actually is beautiful, please just look.
          </p>

          <div className="mt-12 grid grid-cols-3 gap-6 max-w-md">
            {[
              { k: "Years shipping", v: "9+" },
              { k: "Products live", v: "12" },
              { k: "Currencies handled", v: "9" },
            ].map((m) => (
              <div key={m.k} className="border-l border-[var(--bone)]/15 pl-3">
                <div className="font-serif text-3xl md:text-4xl text-[var(--copper)] leading-none">
                  {m.v}
                </div>
                <div className="mt-2 font-mono text-[9px] tracking-[0.2em] uppercase text-[var(--bone-dim)]">
                  {m.k}
                </div>
              </div>
            ))}
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-20%" }}
          transition={{ duration: 0.9, delay: 0.1 }}
          className="md:col-span-6 md:col-start-7"
        >
          <div className="grid grid-cols-2 gap-x-8 gap-y-10">
            {cols.map((c) => (
              <div key={c.label}>
                <div className="font-mono text-[10px] tracking-[0.24em] uppercase text-[var(--copper)] mb-4 pb-3 border-b border-[var(--bone)]/10">
                  {c.label}
                </div>
                <ul className="space-y-2">
                  {c.items.map((i) => (
                    <li
                      key={i}
                      className="text-[var(--bone)]/80 text-sm md:text-base font-light hover:text-[var(--bone)] hover:translate-x-1 transition-all duration-300"
                    >
                      {i}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default About;
